<template>
	<div class="monitored-symptom-list">
		<p
			v-if="monitoredSymptoms.length == 0"
			class="font-weight-thin ml-2"
			v-translate
		>No symptoms being monitored.</p>
		<v-list v-else>
			<MonitoredSymptom
				v-for="mS in monitoredSymptoms"
				:key="mS.id"
				:monitoredSymptom="mS"
				@delete-monitored-symptom="deleteMonitoredSymptom"
				:monitoringTab="monitoringTab"
			/>
		</v-list>
	</div>
</template>

<script>
import MonitoredSymptom from "@/components/patient/MonitoredSymptom.vue";

export default {
	name: "MonitoredSymptomList",
	props: ["monitoredSymptoms","monitoringTab"],
	components: {
		MonitoredSymptom
	},
	data: () => ({}),
	methods: {
		deleteMonitoredSymptom(mS) {
      if(this.monitoringTab) this.$emit("delete-monitored-symptom", mS);
			else this.monitoredSymptoms.splice(this.monitoredSymptoms.indexOf(mS), 1);
		}
	}
};
</script>